import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BoxPlotTwoToneSvg from "@ant-design/icons-svg/es/asn/BoxPlotTwoTone";
import AntdIcon from "../components/AntdIcon";
var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoxPlotTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
}
export default /*#__PURE__*/React.forwardRef(BoxPlotTwoTone);